import rp551 from "./rp551";
import rp552 from "./rp552";
import rp553 from "./rp553";
import rp554 from "./rp554";
import rp555 from "./rp555";
import rp561 from "./rp561";
import rp562 from "./rp562";

import rp1006 from "./rp1006";
import rp1007 from "./rp1007";
import rp1008 from "./rp1008";
import rp1009 from "./rp1009";
import rp1010 from "./rp1010";
import rp1011 from "./rp1011";
import rp1002 from "./rp1002";
import rp1003 from "./rp1003";
import rp1004 from "./rp1004";
import rp1005 from "./rp1005";
import rp1013 from "./rp1013";
import rp1014 from "./rp1014";
import rp571 from "./rp571";
import rp1012 from "./rp1012";
import rp014 from "./rp014";
import rp911 from "./rp911";
import rp1001 from "./rp1001";
import rp1015 from "./rp1015";
import rp1016 from "./rp1016";
import rp1017 from "./rp1017";
import rp1021 from "./rp1021";
import rp1022 from "./rp1022";
import rp1023 from "./rp1023";
import rp1024 from "./rp1024";
import rp1027 from "./rp1027";
import rp1028 from "./rp1028";
import rp1033 from "./rp1033";
import rp1035 from "./rp1035";
import rp402 from "./rp402";
import rp301 from "./rp301";
import atm_log_register from "./atm_log_register";
import atm_card_issue_register from "./atm_card_issue_register";
export default {
  atm_card_issue_register,
  atm_log_register,
  rp301,
  rp402,
  rp1011,
  rp1009,
  rp1008,
  rp1007,
  rp1006,
  rp1035,
  rp1033,
  rp1028,
  rp1027,
  rp1024,
  rp1023,
  rp1022,
  rp1021,
  rp1017,
  rp1016,
  rp1015,
  rp1005,
  rp1004,
  rp1003,
  rp1002,
  rp1001,
  rp911,
  rp1014,
  rp014,
  rp1013,
  rp1012,
  rp571,
  rp562,
  rp561,
  rp555,
  rp554,
  rp553,
  rp552,
  rp551,
};
